import "./LabelCard.scss";
export interface ILabelCardProps {
  label: {
    img: string;
    imgColored: string;
    text: string;
  };
}

export default function LabelCard({ label }: ILabelCardProps) {
  return (
    <div className="label_card_container">
      <div className="label_img_container">
        <img src={label.img} alt="" />
      </div>
      <div className="label_card">
        <img src={label.imgColored} alt="" className="label_img_colored" />
        <div className="text_container">
          <p className="label_text paragraphe"> {label.text}</p>
        </div>
      </div>
    </div>
  );
}
